{
  "resources": "VIEWERS",
  "dimensions": ["OS"],
  "filters": [
    {
      "key": "{{:resourceType:}}",
      "value": "{{:id:}}",
      "op": "=="
    }
  ],
  "dateRange": {
    "start": "{{:startDateTime:}}",
    "end": "{{:endDateTime:}}"
  },
  "size": 1
}